import axios from 'axios'
/**
 * Initial state
 */
export const state = {
  snackbar: null,
  unread: [],
  notifications: {},
  pagination: {
    page: 1,
    rowsPerPage: 10,
  },
  total: null,
  // notificationsCount: null,
}

/**
 * Mutations
 */
export const mutations = {
  ['SET_UNREAD'](state, notifications) {
    state.unread = {}
    const LANG = navigator.language || navigator.userLanguage;
    const OPTIONS = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' , hour:'2-digit', minute:'2-digit'};

    let data = [];
    for (let not in notifications) {
      if (!notifications[not].read_at) {
        data[not] = notifications[not];
        data[not].created_at = new Date((notifications[not].created_at) * 1000) .toLocaleDateString(LANG, OPTIONS);
      }
    }

    state.unread = data
  },
  ['SET_NOTIFICATION'](state, notifications) {
    const LANG = navigator.language || navigator.userLanguage;
    const OPTIONS = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' , hour:'2-digit', minute:'2-digit'};

    let data = [];
    for (let not in notifications) {
      if (!notifications[not].read_at) {
        data[not] = notifications[not];
        data[not].created_at = new Date((notifications[not].created_at) * 1000).toLocaleDateString(LANG, OPTIONS);
      }
    }
    state.unread = notifications;
    state.snackbar = notifications[0];
  },
  ['SET_NOTIFICATIONS_PAGE'](state, payload) {
    state.notifications = payload.data
    state.pagination.page = parseInt(payload.current_page)
    state.pagination.rowsPerPage = parseInt(payload.per_page)
    state.pagination.lastPage = parseInt(payload.last_page)
    state.pagination.totalItems = parseInt(payload.total)
    state.total = parseInt(payload.total)
  },
}

/**
 * Actions
 */
export const actions = {

  fetchUnread({ commit }) {
    axios.get('/api/user/notifications/unread').then(res => {
      if (res.data) {
        commit('SET_UNREAD', res.data)
      }
    }).catch(err => {
      console.error(err);
    });
  },
  readAll({commit}) {
    axios.get(
      '/api/user/notifications/read-all'
    ).then(res => {
      commit('SET_UNREAD', res.data)
    }).catch(err => {
      console.error(err);
    })
  },
  setNew({commit}, notifications) {
    commit('SET_NOTIFICATION', notifications)
  },
  fetchNotifications(context, page){
   let getPage = page.page || context.state.pagination.page;
   let perPage = page.rowsPerPage || context.state.pagination.rowsPerPage;
   axios.get('/api/user/notifications/all?page='+getPage+'&perpage='+perPage).then(res => {
     if (res.data) {
       context.state.pagination = page
       context.commit('SET_NOTIFICATIONS_PAGE', res.data)
     }
   }).catch(err => {
     console.error(err);
   });
  },
}

/**
 * Getters
 */
export const getters = {
  unread: state => state.unread,
  unreadCount: (state) => {
   return state.unread ? state.unread.length : null
  },
  new: state => state.snackbar,
  notifications: state => state.notifications.length > 0 ? state.notifications : [],
  total: state => state.total,
  pagination: state => state.pagination,
  perPage: state => state.pagination ? state.pagination.rowsPerPage : 10,
}
